var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHugeiconsManager(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 22V17C20 15.114 20 14.172 19.414 13.586C18.828 13 17.886 13 16 13L12 22L8 13C6.114 13 5.172 13 4.586 13.586C4 14.172 4 15.114 4 17V22",
    stroke: "#2A62C8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 15L11.5 19L12 20.5L12.5 19L12 15ZM12 15L11 13H13L12 15ZM15.5 6.5V5.5C15.5 5.04037 15.4095 4.58525 15.2336 4.16061C15.0577 3.73597 14.7999 3.35013 14.4749 3.02513C14.1499 2.70012 13.764 2.44231 13.3394 2.26642C12.9148 2.09053 12.4596 2 12 2C11.5404 2 11.0852 2.09053 10.6606 2.26642C10.236 2.44231 9.85013 2.70012 9.52513 3.02513C9.20012 3.35013 8.94231 3.73597 8.76642 4.16061C8.59053 4.58525 8.5 5.04037 8.5 5.5V6.5C8.5 6.95963 8.59053 7.41475 8.76642 7.83939C8.94231 8.26403 9.20012 8.64987 9.52513 8.97487C9.85013 9.29988 10.236 9.55769 10.6606 9.73358C11.0852 9.90947 11.5404 10 12 10C12.4596 10 12.9148 9.90947 13.3394 9.73358C13.764 9.55769 14.1499 9.29988 14.4749 8.97487C14.7999 8.64987 15.0577 8.26403 15.2336 7.83939C15.4095 7.41475 15.5 6.95963 15.5 6.5Z",
    stroke: "#2A62C8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHugeiconsManager);
export default __webpack_public_path__ + "static/media/hugeicons_manager.be45ff47b33555eb233e59b8a7b10b06.svg";
export { ForwardRef as ReactComponent };